module.exports = __webpack_public_path__ + "img/11.94206d29.png";